import React, { forwardRef, useCallback } from 'react'

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  to: string
}

/** ページ内ハッシュリンク。クリック時に対象要素へスムーズスクロールする。 */
export const HashLink = forwardRef<HTMLAnchorElement, Props>(
  ({ to, onClick, ...rest }, ref) => {
    const handleClick = useCallback(
      (e: React.MouseEvent<HTMLAnchorElement>) => {
        onClick?.(e)
        if (e.defaultPrevented) return

        const hash = to.startsWith('#') ? to.slice(1) : to
        const el = document.getElementById(hash)
        if (el) {
          e.preventDefault()
          el.scrollIntoView({ behavior: 'smooth' })
          // URLにhashを反映
          window.history.pushState(null, '', `#${hash}`)
        }
      },
      [to, onClick],
    )

    return <a ref={ref} href={to} onClick={handleClick} {...rest} />
  },
)

HashLink.displayName = 'HashLink'
